import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../../../utils/theme";

export const CardContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  border: 1px solid ${colorPalette.blue200};
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 991.98px) {
    box-shadow: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-top: none;
  }
`;

export const HeaderTitle = styled.h4`
  margin: 0;
  color: ${colorPalette.blue500};
  ${typeScale.bodyXSMain};
`;

export const ChecklistContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 12px;
`;

export const ChecklistItem = styled.div<{ clickable?: boolean; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  cursor: ${({ clickable, disabled }) => (clickable && !disabled ? "pointer" : "default")};
  transition: transform 0.2s ease;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover {
    transform: ${({ clickable, disabled }) => (clickable && !disabled ? "translateX(4px)" : "none")};
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

export const ChecklistIcon = styled.div<{ completed: boolean; disabled?: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ completed, disabled }) =>
    completed ? "linear-gradient(180deg, #136956 0%, #1F4A48 100%);" : disabled ? colorPalette.blue100 : "transparent"};
  border: ${({ completed, disabled }) =>
    completed ? "none" : disabled ? "none" : `1px solid ${colorPalette.textLight}`};

  .empty-circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: transparent;
  }
`;

export const ChecklistContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ChecklistText = styled.span<{ completed: boolean; disabled?: boolean }>`
  margin: 0;
  color: ${({ completed, disabled }) =>
    completed ? colorPalette.textMain : colorPalette.textMain};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  text-decoration: ${({ completed }) => (completed ? "none" : "none")};
  ${typeScale.headingXXSMain};
`;

export const DisabledReason = styled.span`
  margin: 4px 0 0 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXXS};
`;

export const ActionArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;
